module.exports = __webpack_public_path__ + "img/taiwan-startups-m.083d66db.png";